<mat-form-field appearance="fill">
    <mat-select [(ngModel)]="selectedCurrency" name="currOpt" [disabled]="dropdownDisabled"
        (selectionChange)="onCurrencyChange($event)" panelClass="e-mat-select-panel e-currency-select-panel">
        <mat-optgroup *ngFor="let group of currencyOpts">
            <mat-option *ngFor="let opt of group" [value]="opt.currency" [matTooltip]="opt.currencyFullName"
                matTooltipClass="e-mat-tooltip">
                {{ opt.currency }}
            </mat-option>
        </mat-optgroup>
    </mat-select>
</mat-form-field>